<div class="card" *ngIf="contractDetails">
    <div class="card-body">
        <h5>Amortización / Pagos <a class="btn btn-primary" style="float: right;" routerLink="/loans/pay-book/{{contractDetails.id}}">Cupones de pago</a></h5> 
        
        <div class="table-responsive mt-4">
            <table class="table">
            <thead>
                <tr>
                <th scope="col">Fecha de pago</th>
                <th scope="col">Balance</th>
                <th scope="col">Pago</th>
                <th scope="col">Principal</th>
                <th scope="col">Interes</th>
                <th scope="col">Balance Pendiente</th>
                <th scope="col">Referencia</th>
                <th scope="col">Status</th>
                <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let payment of contractDetails.amortization">
                    <td><strong>{{ payment.thisDate | date:'mediumDate' }}</strong></td>
                    <td>{{ payment.thisBeginningBalance | currency }}</td>
                    <td>{{ payment.thisPaymentAmount | currency  }}</td>
                    <td>{{ payment.thisPaidToPrincipal | currency }}</td>
                    <td>{{ payment.thisPaidToInterest | currency }}</td>
                    <td>{{ payment.thisEndingBalance | currency }}</td>
                    <td>{{ payment.reference }}</td>
                    <td *ngIf="payment.paid == 'true' "><span style="color: green;">Pagado</span></td>
                    <td *ngIf="payment.paid == 'false'"><span style="color: red;">Pendiente</span></td>
                    <td *ngIf="!payment.paid"></td>
                    <td><button type="button" (click)="markPaid(payment)" class="btn btn-secondary" data-toggle="modal" data-target="#editPayModal">Editar</button></td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
</div>

 <!-- Modal -->
 <div class="modal fade" id="editPayModal" tabindex="-1" role="dialog" aria-labelledby="editPayModalLabel" aria-hidden="true">
    <div *ngIf="paymentEdit" class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="editPayModalLabel">Pago: {{ paymentEdit.thisPaymentAmount | currency }} | Contrato: {{contractDetails.id}} </h5>
            <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form [formGroup]="editPayForm" (ngSubmit)="editPayment()">
        <div class="modal-body">
            <div class="form-group">
                <label for="reference">Número de refencia</label>
                <input type="text"  class="form-control" id="reference" formControlName="reference">
            </div>
            <div class="form-group">
                <label for="paid">Pagado</label>
                <select class="form-control" id="paid" formControlName="paid">
                    <option value="true">Pagado</option>
                    <option value="false">Pendiente</option>
                </select>
            </div>    
        </div>
        <div *ngIf="missingFieldMsg" class="alert alert-danger" role="alert">
            Falta algun campo...
        </div>
        <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
            Error intente luego...
        </div>
        <div class="modal-footer">
            
            <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Guardar</button>
        </div>
        </form>
        </div>
    </div>
    </div>
